import { ArrowProps } from 'features/products/components/Arrow/Arrow';
import styled from 'styled-components';

export const Styles = {
  Button: styled.button<ArrowProps>`
    background-color: ${({ backgroundColor }) => backgroundColor || 'transparent'};
    transform: ${({ direction }) => {
      if (direction === 'left') {
        return 'rotate(180deg)';
      }
      if (direction === 'up') {
        return 'rotate(-90deg)';
      }
      if (direction === 'down') {
        return 'rotate(90deg)';
      }
    }};
    cursor: pointer;
    height: ${({ height }) => height ?? '48px'};
    width: ${({ width }) => width ?? '48px'};
    border-radius: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    transition: ease-out 0.2s opacity;
    &:disabled {
      cursor: auto;
      opacity: 0.5;
    }
  `,
};
